export const IntranetAdminRequest = {
    path: '/intranet_admin_requests',
    name: 'intranet_admin_requests',
    component: () => import('@/views/Intranet/IntranetAdminRequestPage.vue'),
    children: [
        {
            path: '/intranet_admin_requests/add',
            name: 'intranet_admin_requests.add',
            component: () => import('@/views/Request/Claim/Form/AdminRequestForm.vue'),
            props: {addAction: true, intranet: true}
        },
        {
            path: '/intranet_admin_requests/edit/:id',
            name: 'intranet_admin_requests.edit',
            component: () => import('@/views/Request/Claim/Form/AdminRequestForm.vue'),
            props: {updateAction: true, intranet: true}
        },
        {
            path: '/intranet_admin_requests/delete/:id',
            name: 'intranet_admin_requests.delete',
            component: () => import('@/views/Request/Claim/Form/AdminRequestForm.vue'),
            props: {deleteAction: true, intranet: true}
        },
        {
            path: '/intranet_admin_requests/view/:id',
            name: 'intranet_admin_requests.view',
            component: () => import('@/views/Request/Claim/Form/AdminRequestForm.vue'),
            props: {viewAction: true, intranet: true}
        },
        {
            path: '/intranet_admin_requests/set_decision/:id/:module',
            name: 'intranet_admin_requests.set_decision',
            component: () => import('@/views/Request/Components/SetDecision.vue'),
            props: {module: "ADMIN_REQUEST"}
        },
        {
            path: '/intranet_admin_requests/take_in_charge/:id/:module',
            name: 'intranet_admin_requests.take_in_charge',
            component: () => import('@/views/Request/Components/TakeInCharge.vue'),
        },
        {
            path: '/intranet_admin_requests/timelines/:id',
            name: 'intranet_admin_requests.timelines',
            component: () => import('@/views/Request/Components/ValidationTimelines.vue'),
            props: {module: "ADMIN_REQUEST"}
        },
        {
            path: '/intranet_admin_requests/documents/:id',
            name: 'intranet_admin_requests.documents',
            component: () => import('@/views/Edms/Document/ModuleDocumentPage.vue'),
            props: {module: "ADMIN_REQUEST"}
        },
    ],
}